import {GET_VENDORS,GET_VENDOR_DETAILS} from '../actionTypes'
import{getAxiosInstance} from '../utils/axios-api';
import {getAccessToken} from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';
import {store} from '../store';

export const getVendors = () => async dispatch => {
    try{
    const response = await getAxiosInstance().get(
        `/vendors?isBoth=true&access_token=${getAccessToken()}`       
    );
    if(response.status===200){
        dispatch({
            type: GET_VENDORS,
            payload: response.data||undefined
        });
    }else{
        dispatch({
            type: GET_VENDORS,
            payload: undefined
        });
    } 
    }catch(ex){
        dispatch({
            type: GET_VENDORS,
            payload: undefined
        });
    }   
};
export const deleteVendor=(status,vendorId)=> async dispatch => {
    try{
        if((vendorId||0)>0){
            const response = await getAxiosInstance().delete(
                `/vendors/${vendorId}?isActive=${status}&access_token=${getAccessToken()}`,      
            );
            if(response.status===200){
                notify('success',"Vendor deleted successfully");  
                return true;            
            }
            else{
                notify('error',"Vendor deleted failed");
                return false
            }
        }else{
            return false;
        }
    }catch(ex){
        return false
    }
}
export const saveVendor=(body,vendorId)=>async dispatch=>{
    body['cityStateZip'] = `${body.addressCity},${body.addressState},${body.addressZip}`;
    try{
        if((vendorId||0)>0){
            const response = await getAxiosInstance().put(
                `/vendors/${vendorId}?access_token=${getAccessToken()}`, body      
            );
            if(response.status===200){
                notify('success',"Vendor updated successfully");  
                return true;            
            }
            else{
                notify('error',"Vendor updated failed");
                return false
            }
        }else{
            const response = await getAxiosInstance().post(
                `/vendors?access_token=${getAccessToken()}`, body      
            );
            if(response.status===200){
            notify('success',"Vendor inserted successfully");
            return true;              
            }
            else{
                notify('error',"Vendor inserted failed");
                return false;
            }
        }
    }catch(ex){
        notify('error',"Something went wrong. Please try again");
        return false;
    }    
}
export const getSelectedVendor = (vendorId) => async dispatch => {
        const vendorList = store.getState().vendorsList.vendors;
        if(vendorList.length > 0){
        const selectedVendor = vendorList.filter(_vendor=> {return _vendor.vendorId===vendorId})[0]||{};
        let obj = (selectedVendor.cityStateZip||''!=='') ? selectedVendor.cityStateZip.split(',') : '';
        selectedVendor['addressCity']=obj[0];
        selectedVendor['addressState']=obj[1];
        selectedVendor['addressZip']=obj[2];
        dispatch({
            type: GET_VENDOR_DETAILS,
            payload: selectedVendor || undefined
        });
    }else{
        dispatch({
            type: GET_VENDOR_DETAILS,
            payload: undefined
        }); 
    }
};
export const clearVendor = () => async dispatch => {    
    dispatch({
        type: GET_VENDOR_DETAILS,
        payload: undefined
    });
};
